import React, { useState, useEffect } from 'react';
import '../styles/LandingPage.css';
import { supabase } from '../lib/supabaseClient';
import { capitalizeName } from '../lib/format';

// ─── NAV ───────────────────────────────────────────────────────────────────
const Nav = ({ onNavigate }) => {
  console.log('Nav onNavigate type:', typeof onNavigate);
  const [scrolled,    setScrolled]    = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);

  const SHOW_AUTH = true; // true = show Sign In / Sign Up in nav

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-logo">
          Umpire<span className="nav-logo-accent">IQ</span>
        </div>
        <ul className="nav-links">
          <li><a href="#how">How It Works</a></li>
          <li><a href="#pricing">Pricing</a></li>
          <li><a href="#badge">The Badge</a></li>
          <li>
            <a href="#" onClick={e => { e.preventDefault(); onNavigate('search'); }}>
              Find Umpires
            </a>
          </li>
          <li>
            <a href="#" onClick={e => { e.preventDefault(); onNavigate('blog'); }}>
              Blog
            </a>
          </li>
          {SHOW_AUTH && (
            <li>
              <button
                className="nav-cta"
                style={{ background: '', color: 'var(--navy)', border: '', cursor: 'pointer' }}
                onClick={async () => {
                  const { data: { session } } = await supabase.auth.getSession();
                  if (session) {
                    onNavigate('dashboard');
                  } else {
                    onNavigate('login');
                  }
                }}
              > Sign In
              </button>
            </li>
          )}
          {SHOW_AUTH && (
            <li>
              <button className="nav-cta" onClick={() => onNavigate('signup')} style={{ border: 'none', cursor: 'pointer' }}>
              Sign Up
              </button>
            </li>
          )}
        </ul>

        <div className="nav-mobile-btn">
          <button className="nav-hamburger" onClick={() => setMenuOpen(m => !m)}>
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="nav-mobile-menu">
          <a href="#how"      onClick={() => setMenuOpen(false)}>How It Works</a>
          <a href="#pricing"  onClick={() => setMenuOpen(false)}>Pricing</a>
          <a href="#badge"    onClick={() => setMenuOpen(false)}>The Badge</a>
          <a href="#" onClick={e => { e.preventDefault(); onNavigate('search'); }}>Find Umpires</a>
          <a href="#" onClick={e => { e.preventDefault(); setMenuOpen(false); onNavigate('blog'); }}>Blog</a>
          {SHOW_AUTH && (
            <>
            <button onClick={() => { setMenuOpen(false); onNavigate('signup'); }}>Sign Up</button>
            <button onClick={() => { setMenuOpen(false); onNavigate('login'); }}>Sign In</button>
            </>
          )}
        </div>
      )}
    </>
  );
};

// ─── PROFILE CARD ──────────────────────────────────────────────────────────
const ProfileCard = () => (
  <div className="profile-card animate-fadeUp delay-3">
    <div className="profile-card-badge">Peer Reviewed</div>
    <div className="profile-card-header">
      <div className="profile-avatar">JM</div>
      <div>
        <div className="profile-name">James R. Mitchell</div>
        <div className="profile-meta">SCLA, ACA, WIND · Florida</div>
      </div>
    </div>
    <div className="rating-row">
      <div className="rating-stars">
        {[1,2,3,4,5].map(star => (
          <svg key={star} width="20" height="20" viewBox="0 0 20 20" fill={star <= 4 ? 'var(--gold)' : 'none'} xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id={`partial-${star}`} x1="0" x2="1" y1="0" y2="0">
                <stop offset="23%" stopColor="var(--gold)" />
                <stop offset="23%" stopColor="var(--border)" />
              </linearGradient>
            </defs>
            <polygon
              points="10,1 12.9,7 19.5,7.6 14.5,12 16.2,18.5 10,15 3.8,18.5 5.5,12 0.5,7.6 7.1,7"
              fill={star === 5 ? 'url(#partial-5)' : star <= 4 ? 'var(--gold)' : 'var(--border)'}
              stroke="var(--gold)"
              strokeWidth="0.5"
            />
          </svg>
        ))}
      </div>
      <span className="rating-avg">4.13</span>
      <span className="rating-count">(71 votes)</span>
    </div>

    <div className="endorsement-grid">
      <div className="endorsement-box">
        <div className="endorsement-num">14</div>
        <div className="endorsement-label">IA Endorsements</div>
      </div>
      <div className="endorsement-box">
        <div className="endorsement-num">17</div>
        <div className="endorsement-label">PA Endorsements</div>
      </div>
    </div>
    <div className="balance-bar">
      <span className="balance-label">IA</span>
      <div className="balance-track">
        <div className="balance-fill" />
      </div>
      <span className="balance-label">PA</span>
      <span className="balance-score" style={{ marginLeft: '10px' }}></span>
    </div>

  </div>
);

// ─── EMAIL FORM ────────────────────────────────────────────────────────────
// EmailJS config — replace these with your actual values from emailjs.com
const EmailForm = ({ className = 'hero-form', btnClass = 'hero-form-btn', placeholder = 'your@firm.com', btnText = 'Join Waitlist' }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!email) return;
  setLoading(true);
  setError('');

  try {
    const res = await fetch('https://formspree.io/f/xzdweogw', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });

    if (res.ok) {
      setSubmitted(true);
    } else {
      setError('Something went wrong. Please email admin@umpire-iq.com directly.');
    }
  } catch {
    setError('Something went wrong. Please email admin@umpire-iq.com directly.');
  } finally {
    setLoading(false);
  }
};

  if (submitted) {
    return (
      <div style={{ padding: '14px 0', color: 'var(--gold)', fontSize: '15px', fontWeight: 500 }}>
        ✓ You're on the list. We'll be in touch.
      </div>
    );
  }

  return (
    <div>
      <form className={className} onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder={placeholder}
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button type="submit" className={btnClass} disabled={loading}>
          {loading ? 'Sending...' : btnText}
        </button>
      </form>
      {error && <p style={{ color: '#c0392b', fontSize: '12px', marginTop: '8px' }}>{error}</p>}
    </div>
  );
};

// ─── HERO ──────────────────────────────────────────────────────────────────
const Hero = ({ onNavigate }) => (
  <section className="hero">
    <div className="hero-bg">
      <div className="hero-bg-circle" />
      <div className="hero-bg-line" />
    </div>
    <div className="hero-inner">
      <div className="hero-left">
        <div className="hero-eyebrow animate-fadeUp delay-1">
          Insurance Appraisal Intelligence
        </div>
        <h1 className="hero-h1 animate-fadeUp delay-2">
          Both sides<br />deserve the <em>truth.</em>
        </h1>
        <p className="hero-sub animate-fadeUp delay-3">
          The insurance claims industry's first peer-audited umpire intelligence platform. Find neutral umpires. Verify their work. Hire with confidence.
        </p>
        <div className="animate-fadeUp delay-4">
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
            <button className="hero-form-btn" onClick={() => onNavigate('signup')}>
              Claim your profile
            </button>
            <button
              onClick={() => onNavigate('login')}
              style={{ background: 'none', border: 'none', color: 'var(--gold)', fontSize: '14px', fontWeight: 500, fontFamily: 'var(--sans)', cursor: 'pointer' }}
            >
              Sign in
            </button>
          </div>
          <p className="hero-note">For public adjusters, independent appraisers, attorneys, and courts.</p>
        </div>
      </div>
      <div className="hero-right">
        <ProfileCard />
      </div>
    </div>
  </section>
);

// ─── TRUST BAR ─────────────────────────────────────────────────────────────
const TrustBar = () => (
  <div className="trust-bar">
    <div className="trust-inner">
      <span className="trust-label">Built for</span>
      <div className="trust-divider" />
      <div className="trust-items">
        {['Public Adjusters', 'Insurance Appraisers', 'Claims Attorneys', 'Court Appointments', 'Assignors'].map(item => (
          <span key={item} className="trust-item">
            <span className="trust-dot" />
            {item}
          </span>
        ))}
      </div>
    </div>
  </div>
);

// ─── VALUE PROPS ───────────────────────────────────────────────────────────
const props = [
  {
    num: '01',
    title: 'Find neutral umpires',
    body: 'Search by state, county, claim type, certifications, and endorsement balance. Filter for WIND or IAUA certified professionals. See the IA-to-PA split before you agree to anyone.'
  },
  {
    num: '02',
    title: 'Verify their work',
    body: 'Peer Reviewed badges are earned through a random-sample audit of real, redacted claim files — reviewed by verified IAs and PAs from both sides. Not coursework. Actual outcomes.'
  },
  {
    num: '03',
    title: 'Hire with confidence',
    body: 'A balanced endorsement profile is the only profile that earns a high overall score. Fairness becomes the path to more work — aligning every incentive in the right direction.'
  }
];

const ValueProps = () => (
  <section className="section" id="how">
    <div className="section-inner">
      <div className="eyebrow">Why UmpireIQ</div>
      <h2 className="section-h2">
        Built for every<br />side of the <em>panel.</em>
      </h2>
      <p className="section-sub">
        The only platform where IA and PA endorsements are tracked separately — making neutrality visible for the first time.
      </p>
      <div className="props-grid">
        {props.map(p => (
          <div key={p.num} className="prop-card">
            <div className="prop-num">{p.num}</div>
            <div className="prop-title">{p.title}</div>
            <p className="prop-body">{p.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── TIERS ─────────────────────────────────────────────────────────────────
const tiers = [
  {
    name: 'Free',
    price: '0',
    period: 'forever',
    featured: false,
    features: [
      'Basic profile from public license records',
      'Name, state, certifications visible',
      'Appears in general browse',
      'Endorsement count displayed',
      'Star ratings displayeed',
    ],
    cta: 'Claim free profile'
  },
  {
    name: 'Premium',
    price: '25',
    period: 'per month',
    featured: false,
    features: [
      'Full profile with bio & headshot',
      'Can rate umpires',
      'Can leave recomendations',
      'Can vote on old survey questins',
      'Appears in certification-filtered searches',
      'County-level search visibility',
      'Claim specialty filters',
      'Certification badges displayed',
      'Contact button enabled'
    ],
    cta: 'Start premium'
  },
  {
    name: 'Peer Reviewed',
    price: '250',
    period: 'per month · 12-month agreement',
    featured: true,
    featuredTag: 'Most Credible',
    features: [
      'Everything in Premium',
      'Random-sample file audit',
      'Reviewed by 3 IAs + 3 PAs',
      'Peer Reviewed badge on profile',
      'Priority placement in all searches',
      'Court-ready intelligence documentation',
      'Annual renewal audit'
    ],
    cta: 'Apply for badge'
  }
];

const Tiers = ({onNavigate}) => (
  <section className="section section-cream" id="pricing">
    <div className="section-inner">
      <div className="eyebrow">Pricing</div>
      <h2 className="section-h2">
        Simple, transparent<br /><em>tiers.</em>
      </h2>
      <p className="section-sub">
        Free to search. Umpires control their visibility. The Peer Reviewed badge is earned — not bought.
      </p>
      <div className="tiers-grid">
        {tiers.map(tier => (
          <div key={tier.name} className={`tier-card ${tier.featured ? 'featured' : ''}`}>
            {tier.featured && <div className="tier-featured-tag">{tier.featuredTag}</div>}
            <div className="tier-name">{tier.name}</div>
            <div className="tier-price">
              <span className="tier-price-dollar">$</span>
              {tier.price}
            </div>
            <div className="tier-period">{tier.period}</div>
            <div className="tier-divider" />
            <ul className="tier-features">
              {tier.features.map(f => (
                <li key={f} className="tier-feature">
                  <span className="tier-feature-dash">—</span>
                  {f}
                </li>
              ))}
            </ul>
            <button
              className="tier-btn"
              disabled={tier.name === 'Peer Reviewed'}
              title={tier.name === 'Peer Reviewed' ? 'Coming Sept 2026' : undefined}
              onClick={() => {
                if (tier.name === 'Premium') window.open('https://buy.stripe.com/6oU00k2Lr2Jy8uI28i6wE00', '_blank');
                if (tier.name === 'Free') onNavigate('signup');
              }}
              style={tier.name === 'Peer Reviewed' ? { opacity: 0.45, cursor: 'not-allowed' } : undefined}
            >
              {tier.name === 'Peer Reviewed' ? 'Coming Sept 2026' : tier.cta}
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── STEPS ─────────────────────────────────────────────────────────────────
const steps = [
  {
    num: '1',
    title: 'Submit your file list',
    body: 'Provide a complete, attested list of all umpire assignments in the past 24 months. Claim number, date, type. Signed under attestation.'
  },
  {
    num: '2',
    title: 'We select randomly',
    body: 'UmpireIQ randomly selects 3 files from your list. You prepare those specific files — fully redacted, PII-free, flat PDF with written narrative.'
  },
  {
    num: '3',
    title: 'Peer panel reviews',
    body: '3 verified IAs and 3 PAs from your state independently evaluate each file against a structured rubric.'
  },
  {
    num: '4',
    title: 'Badge awarded',
    body: '66% majority score earns the Peer Reviewed badge. Renewed annually. The industry\'s most credible umpire intelligence.'
  }
];

const Steps = () => (
  <section className="section" id="badge">
    <div className="section-inner">
      <div className="eyebrow">The Peer Review Process</div>
      <h2 className="section-h2">
        How the badge<br />is <em>earned.</em>
      </h2>
      <p className="section-sub">
        A rigorous, random-sample audit of actual claim outcomes. No cherry-picking. No coursework. Real work, independently reviewed.
      </p>
      <div className="steps-grid">
        <div className="steps-connector" />
        {steps.map(step => (
          <div key={step.num} className="step">
            <div className="step-dot">
              <span className="step-num">{step.num}</span>
            </div>
            <div className="step-title">{step.title}</div>
            <p className="step-body">{step.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// ─── CTA ───────────────────────────────────────────────────────────────────
const CTA = ({ onNavigate }) => (
  <section className="section section-navy" id="get-started">
    <div className="cta-inner">
      <div className="eyebrow" style={{ justifyContent: 'center', color: 'rgba(184,135,58,0.9)' }}>
        Now Live
      </div>
      <h2 className="section-h2 light" style={{ textAlign: 'center' }}>
        The claims industry<br />deserves <em>better data.</em>
      </h2>
      <p className="section-sub light" style={{ textAlign: 'center', margin: '16px auto 40px' }}>
        Create your free profile today. Claim your listing, get verified, and start building your reputation.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button className="cta-btn" onClick={() => onNavigate('signup')}>
          Create free profile
        </button>
      </div>
      <p className="cta-note">Free to join. No credit card required.</p>
    </div>
  </section>
);

// ─── FOOTER ────────────────────────────────────────────────────────────────
const Footer = ({ onNavigate }) => (
  <footer className="footer">
    <div className="footer-logo">
      Umpire<span className="footer-logo-accent">IQ</span>
    </div>
    <ul className="footer-links">
      <li><a href="#" onClick={e => { e.preventDefault(); onNavigate('blog'); }}>Blog</a></li>
      <li><a href="#" onClick={e => { e.preventDefault(); onNavigate('privacy'); }}>Privacy Policy</a></li>
      <li><a href="#" onClick={e => { e.preventDefault(); onNavigate('terms'); }}>Terms of Service</a></li>
      <li><a href="mailto:admin@umpire-iq.com">Contact</a></li>
    </ul>
    <div className="footer-copy">© {new Date().getFullYear()} Golf Data Assessors, LLC. All rights reserved. &nbsp;·&nbsp; ver. 1.06</div>
  </footer>
);

// ─── PAGE ──────────────────────────────────────────────────────────────────
const LandingPage = ({ onNavigate }) => (
  <>
    <Nav onNavigate={onNavigate} />
    <Hero onNavigate={onNavigate} />
    <TrustBar />
    <ValueProps />
    <Tiers onNavigate={onNavigate} />
    <Steps />
    <CTA onNavigate={onNavigate} />
    <Footer onNavigate={onNavigate} />
  </>
);

export default LandingPage;
